import { render, staticRenderFns } from "./PatientClinicalDocuments.vue?vue&type=template&id=596071dc&scoped=true"
import script from "./PatientClinicalDocuments.vue?vue&type=script&lang=js"
export * from "./PatientClinicalDocuments.vue?vue&type=script&lang=js"
import style0 from "./PatientClinicalDocuments.scss?vue&type=style&index=0&id=596071dc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596071dc",
  null
  
)

export default component.exports